/* eslint-disable camelcase */
import { Action, ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { StateObservable } from 'redux-observable';
import { Observable, from, of } from 'rxjs';
import {
  switchMap, flatMap, tap, catchError, filter,
} from 'rxjs/operators';

import { logClientError } from '@ezugi/bootstrap/src/util/logUtils';
import { GenericPayloadType } from '@ezugi/types';
import { handleError } from '@ezugi/utils';

import { configActions, localeActions, errorActions } from '../../actions';
import { authSelector, userSelector } from '../../selectors';
import { RootState } from '../../types';
import { changeLanguage } from './utils';

const { locale } = localeActions;
const { config } = configActions;

type AuthParams = {
  game_id?: string;
  table_id?: string;
  token?: string;
};

type ChangeLanguageParams = {
  language: string;
  operator_id: string;
  game_id: string;
  table_id: string;
  identifier: string;
}

const localeChangeEpic = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(locale.change.match),
  switchMap(({ payload: { code } }) => {
    const { game_id, table_id, token }: AuthParams = authSelector(state$.value) || {};
    const { operatorId } = userSelector(state$.value);

    const params: ChangeLanguageParams = {
      language: code,
      operator_id: String(operatorId || ''),
      game_id: game_id || '',
      table_id: table_id || '',
      identifier: `${operatorId}${token}`,
    };

    return from(changeLanguage(params));
  }),
  tap(({ code }) => {
    document.documentElement.lang = code;
  }),
  flatMap(({ response: { result }, code }: { response: Record<string, any>, code: string }) => of(
    locale.set({ locales: result.locale, lang: code }),
    config.update({ general: { language: code } })
  )),
  catchError((error) => handleError({
    error,
    failAction: errorActions.error.set as unknown as ActionCreatorWithPayload<GenericPayloadType>,
    options: {
      clientErrorHandler: logClientError,
    },
  }))
);

export default localeChangeEpic;
